module.exports = __webpack_public_path__ + "static/media/avatars_female_4.db847955.png";